import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Group, PostGroup, PutGroup } from 'src/app/interfaces/api/group';
import { environment } from 'src/environments/environment';
import { ApiService } from '../../core/api.service';

type QueryParams = Record<string, string | number | boolean | Date | Array<string | number | boolean | Date> | object>;

@Injectable({
  providedIn: 'root'
})

export class GroupService {

  collection = "Group";
  collectionPath = "groups";
  groups: Group[] = [];
  apiUrl = environment.API_URL;

  constructor(
    private apiService: ApiService,
    public http: HttpClient,
  ) { }

  //---GET---//

  getGroups(query: QueryParams = {}): Observable<Group[]> {
    return this.apiService.getCollection( this.collectionPath, "", query);
  }

  //---POST---//

  addGroup(group: PostGroup): Observable<any> {
    return this.apiService.postCollectionData( this.collectionPath, "", group);
  }

  //---PUT---//

  updateGroup(group: PutGroup): Observable<any> {
    return this.apiService.updateCollectionItem( this.collectionPath, group);
  }

  //---DELETE---//

  removeGroup(groupId: string): Observable<any> {
    return this.apiService.deleteCollectionItem( this.collectionPath, groupId);
  }
}
